import React from 'react';
import { Col, Form } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css'; // Asegúrate de que el estilo esté importado

// Phone
const PhoneInputComponent = ({
  formFound,
  phoneNumber,
  setPhoneNumber,
  phonePais,
  valuesRequired,
  values,
  handleInputChange,
  validatePhoneNumber,
}) => {
  return (
    <Col lg={4} xs={12} className="mb-3">
      <Form.Group controlId={'validationCustom'}>
        <Form.Label>{formFound?.phone?.name + ' *'}</Form.Label>
        <div className="d-flex">
          <PhoneInput
            autoComplete="off"
            international
            className="custom-phone-input phone-num"
            defaultCountry="AR"
            value={phoneNumber}
            onChange={setPhoneNumber}
          />
          <Form.Control
            name="phone"
            type="text"
            className="phone-input"
            value={phonePais === phoneNumber ? valuesRequired.phone : phoneNumber}
            onChange={handleInputChange}
            autoComplete="off"
            required
            isValid={validatePhoneNumber(valuesRequired.phone)}
            isInvalid={
              values.phone?.length > 2 && !validatePhoneNumber(valuesRequired.phone)
            }
          />
        </div>
      </Form.Group>
    </Col>
  );
};

export default PhoneInputComponent;
